import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import { formatCurrency } from '../../../utility/helpers/displayHelper';

const ShopSuppliesTable = ({ item, index, invoiceData }) => {
    return (
        <Grid container item key={index}>
            <Grid
                container
                item
                sx={{
                    bgcolor: 'secondary.main',
                    color: 'white',
                    marginTop: '20px',
                    borderTopLeftRadius: '4px',
                    borderTopRightRadius: '4px',
                }}
            >
                <Grid item lg={12} md={12} sm={12} xs={12}>
                    <Typography variant="h6" fontWeight={'500'} padding={'16px'}>
                        Shop Supplies
                    </Typography>
                </Grid>
            </Grid>
            <Grid container item>
                <Grid item xl={12} md={12} sm={12} xs={12} boxShadow={0}>
                    <TableContainer style={{ minWidth: '850px' }}>
                        <Table aria-label="caption table" padding="16px">
                            <TableHead
                                style={{
                                    backgroundColor: '#f4f6f8',
                                    fontWeight: 500,
                                }}
                            >
                                <TableRow>
                                    <TableCell width={'120px'}>No.</TableCell>
                                    <TableCell style={{ minWidth: '312px' }}> Description</TableCell>
                                    <TableCell width={'120px'} align="right">
                                        Quantity
                                    </TableCell>
                                    <TableCell width={'120px'} align="right">
                                        Price
                                    </TableCell>
                                    <TableCell width={'120px'} align="right" sx={{ paddingRight: '23px' }}>
                                        Amount
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {invoiceData &&
                                    invoiceData?.shopSupplies?.map((row, index) => (
                                        <TableRow key={row?._id}>
                                            <TableCell component="th" scope="row" width={'120px'}>
                                                {index + 1}
                                            </TableCell>
                                            <TableCell align="left">{row?.itemName}</TableCell>
                                            <TableCell align="right" width={'120px'}>
                                                {row?.qty}
                                            </TableCell>
                                            <TableCell align="right" width={'120px'}>
                                                {row?.cost ? formatCurrency(row?.cost) : '$0'}
                                            </TableCell>
                                            <TableCell align="right" style={{ paddingRight: '23px' }}>
                                                {row?.totalAmount ? formatCurrency(row?.totalAmount) : '$0'}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default ShopSuppliesTable;
